"use client";

import { useEffect } from "react";

import {
  getNavigationType,
  takeDuplicatedTabReloadDecision,
} from "@/shared/utils/duplicated-tab-recovery.util";

export function DuplicatedTabRecovery() {
  useEffect(() => {
    const reloadIfRestored = (persisted?: boolean) => {
      if (
        takeDuplicatedTabReloadDecision({
          navigationType: getNavigationType(),
          persisted,
        })
      ) {
        window.location.reload();
      }
    };

    reloadIfRestored();

    const onPageShow = (event: PageTransitionEvent) => {
      reloadIfRestored(event.persisted);
    };

    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  return null;
}
